import { cn } from "@bidbattles/bloks/lib/ui";

function Divider({
	className,
	render,
}: {
	className?: string;
	render?: (
		props: React.PropsWithChildren<{ className: string }>,
	) => React.ReactElement;
}) {
	const classes = cn("bg-gray-300 border-gray-300 w-full", className);
	if (render) {
		return render({ className: classes });
	}

	return <hr className={classes} />;
}

export { Divider };
